import React, { useEffect, useState } from "react";
import { get_locales_puntoventa } from "../../../../actions/local";
import { SelectUi } from "../../../ui/SelectUi";

export const LocalPuntoVentaSelect = ({ ...props }) => {
  const [locales, setLocales] = useState([]);
  const OnLoadLocales = async () => {
    const datos = await get_locales_puntoventa();
    setLocales(datos);
  };
  useEffect(() => {
    OnLoadLocales();
  }, []);

  return <SelectUi data={locales} {...props} />;
};
